module.exports = __webpack_public_path__ + "assets/ic-www.17cd12e3.svg";